import Vue from 'vue'
import ucDetailDefault from './iconsBase/ucDetailDefault'
import * as handleModules from './handleModules'

export default {
  options: {
    message: {
      bus: new Vue()
    },
    getOpenUrl: function({ url, params }) {
      if(url.startsWith('./')){
        url = url.slice(2)
      }else if(url.startsWith('/')){
        url = url.slice(1)
      }
      return handleModules.getOpenUrl({ url, params })
    },
    getFileUrl: function() {
      return ucDetailDefault.src
    },
    urls: {
      ClueDig: {
        TopicHotDetail: 'MediaCloudNewsPlan-TopicHotDetail',
        NewsDetail: 'MediaCloudNewsPlan-NewsDetail',
        ArticleAdd: 'MediaCloudNewsPlan-ArticleAdd'
      },
      Discuss: {
        DiscussArticleDetail: 'MediaCloudManageCenter-DiscussArticleDetail'
      },
      Mobile: {
        ArticleAdd: 'MediaCloudPublishCenter-ArticleAdd',
        ArticleEdit: 'MediaCloudPublishCenter-ArticleAdd',
        ArticleAddPhoto: 'MediaCloudPublishCenter-ArticleAddPhoto',
        ArticleAddVideo: 'MediaCloudPublishCenter-ArticleAddVideo',
        ArticleAddAudio: 'MediaCloudPublishCenter-ArticleAddAudio',
        ArticleAddLink: 'MediaCloudPublishCenter-ArticleAddLink',
        ArticleDetail: 'MediaCloudPublishCenter-ArticleDetail',
        ArticleAddSpecial: 'MediaCloudPublishCenter-ArticleAddSpecial',
        ArticleAddLive: 'MediaCloudPublishCenter-ArticleAddLive',
        ArticleTraces: 'MediaCloudPublishCenter-ArticleTraces',
        ArticleAddVote: 'MediaCloudPublishCenter-ArticleAddVote',
        ArticleAddSubject: 'MediaCloudPublishCenter-ArticleAddSubject',
        ArticleAddActivity: 'MediaCloudPublishCenter-ArticleAddActivity',
        ArticleToVideo: 'MediaCloudPublishCenter-ArticleToVideo'
      },
      OtherArticle: {
        ArticleAdd: 'MediaCloudPublishCenter-ArticleAdd',
        ArticleAddPhoto: 'MediaCloudPublishCenter-ArticleAddPhoto',
        ArticleAddVideo: 'MediaCloudPublishCenter-ArticleAddVideo',
        ArticleDetail: 'MediaCloudPublishCenter-ArticleDetail',
        ArticleTraces: 'MediaCloudPublishCenter-ArticleTraces'
      },
      RootArticle: {
        RootArticleAdd: 'MediaCloudPublishCenter-RootArticleAdd',
        RootArticleEdit: 'MediaCloudPublishCenter-RootArticleAdd',
        RootArticleAddPhoto: 'MediaCloudPublishCenter-RootArticleAddPhoto',
        RootArticleAddVideo: 'MediaCloudPublishCenter-RootArticleAddVideo',
        RootArticleAddAudio: 'MediaCloudPublishCenter-RootArticleAddAudio',
        RootArticleAddLink: 'MediaCloudPublishCenter-RootArticleAddLink',
        RootArticleTraces: 'MediaCloudPublishCenter-RootArticleTraces',
        RootArticleDetail: 'MediaCloudPublishCenter-RootArticleDetail',
        RootArticleToVideo: 'MediaCloudPublishCenter-RootArticleToVideo'
      },
      Weixin: {
        WxArticleAdd: 'MediaCloudPublishCenter-WxArticleAdd',
        WxArticleDetail: 'MediaCloudPublishCenter-WxArticleDetail',
        WxgArticleAdd: 'MediaCloudPublishCenter-WxgArticleAdd',
        WxgArticleEdit: 'MediaCloudPublishCenter-WxgArticleAdd'
      },
      Weibo: {
        WbArticleAdd: 'MediaCloudPublishCenter-WbArticleAdd',
        WbArticleEdit: 'MediaCloudPublishCenter-WbArticleAdd'
      },
      DouyinArticle: {
        DouyinArticleAddPhoto: 'MediaCloudPublishCenter-DouyinArticleAddPhoto',
        DouyinArticleAddVideo: 'MediaCloudPublishCenter-DouyinArticleAddVideo',
        DouyinArticleDetail: 'MediaCloudPublishCenter-DouyinArticleDetail'
      },
      Clues: {
        ClueAdd: 'MediaCloudNewsPlan-ClueAdd',
        ClueEdit: 'MediaCloudNewsPlan-ClueAdd',
        ClueDetail: 'MediaCloudNewsPlan-ClueDetail',
        TaskAssign: 'MediaCloudNewsPlan-TaskAssign',
        ClueToTopic: 'MediaCloudNewsPlan-ClueToTopic'
      },
      Topics: {
        TopicAdd: 'MediaCloudNewsPlan-TopicAdd',
        TopicDetail: 'MediaCloudNewsPlan-TopicDetail',
        TaskAssign: 'MediaCloudNewsPlan-TaskAssign',
        ArticleDetail: 'MediaCloudNewsPlan-ArticleDetail'
      },
      Tasks: {
        TaskDetail: 'MediaCloudNewsPlan-TaskDetail',
        TaskAdd: 'MediaCloudNewsPlan-TaskAdd',
        ArticleDetail: 'MediaCloudNewsPlan-ArticleDetail'
      },
      Photo: {
        PhotoDetail: 'MediaCloudManageCenter-PhotoDetail'
      },
      Video: {
        VideoDetail: 'MediaCloudMAM-VideoDetail',
        VideoQuickEdit: 'MediaCloudMAM-VideoQuickEdit'
      },
      Audio: {
        AudioDetail: 'MediaCloudMAM-AudioDetail'
      },
      CommandAssignment: {
        RRCommandAdd: 'MediaCloudRemoteRepository-RRCommandAdd',
        RRArticleDetail: 'MediaCloudRemoteRepository-RRArticleDetail',
        RRCommandEdit: 'MediaCloudRemoteRepository-RRCommandEdit',
        RRCommandDetail: 'MediaCloudRemoteRepository-RRCommandDetail',
        RRArticleEdit: 'MediaCloudRemoteRepository-RRArticleEdit'
      },
      MCArticle: {
        MCArticleToCommand: 'MediaCloudRemoteRepository-MCArticleToCommand',
        MCArticleDetail: 'MediaCloudRemoteRepository-MCArticleDetail',
        MCArticleEdit: 'MediaCloudRemoteRepository-MCArticleEdit',
        ArticleAdd: 'MediaCloudRemoteRepository-ArticleAdd'
      },
      MBDArticle: {
        MBDArticleDetail: 'MediaCloudRemoteRepository-MBDArticleDetail',
        MBDArticleToCommand: 'MediaCloudRemoteRepository-MBDArticleToCommand',
        MBDArticleEdit: 'MediaCloudRemoteRepository-MBDArticleEdit',
        ArticleAdd: 'MediaCloudRemoteRepository-ArticleAdd'
      },
      AMArticle: {
        AMArticleDetail: 'MediaCloudRemoteRepository-AMArticleDetail',
        AMArticleToCommand: 'MediaCloudRemoteRepository-AMArticleToCommand',
        AMArticleEdit: 'MediaCloudRemoteRepository-AMArticleEdit',
        ArticleAdd: 'MediaCloudRemoteRepository-ArticleAdd'
      },
      RRRootArticle: {
        RRRootArticleDetail: 'MediaCloudRemoteRepository-RRRootArticleDetail',
        RRRootArticleToCommand:
          'MediaCloudRemoteRepository-RRRootArticleToCommand',
        RRRootArticleEdit: 'MediaCloudRemoteRepository-RRRootArticleEdit',
        ArticleAdd: 'MediaCloudRemoteRepository-ArticleAdd'
      },
      ArticleDetail: {
        TaskAssign: 'MediaCloudNewsPlan-TaskAssign',
        ClueToTopic: 'MediaCloudNewsPlan-ClueToTopic',
        MBDArticleToCommand: 'MediaCloudRemoteRepository-MBDArticleToCommand'
      },
      QA: {
        QAConfig: 'MediaCloudNis-QAConfig',
        QADetail: 'MediaCloudNis-QADetail'
      },
      Tipoff: {
        TipoffArticleEdit: 'MediaCloudNis-TipoffArticleEdit',
        TipoffToClue: 'MediaCloudNis-TipoffToClue'
      },
      Subject: {
        SubjectDetail: 'MediaCloudNis-SubjectDetail'
      },
      Live: {
        LiveConsole: 'MediaCloudNis-LiveConsole',
        LiveDetail: 'MediaCloudNis-LiveDetail'
      },
      Vote: {
        VoteAdd: 'MediaCloudNis-VoteAdd',
        VoteEdit: 'MediaCloudNis-VoteAdd',
        VoteResult: 'MediaCloudNis-VoteResult'
      },
      Activity: {
        ActivityResult: 'MediaCloudNis-ActivityResult'
      },
      Panel: {
        CommandReceiver: 'MediaCloudPortal-CommandReceiver',
        Notice: 'MediaCloudPortal-Notice',
        MyNotice: 'MediaCloudPortal-MyNotice',
        RRCommandDetail: 'MediaCloudPortal-RRCommandDetail',
        RRArticleDetail: 'MediaCloudPortal-RRArticleDetail',
        RootArticleDetail: 'MediaCloudPortal-RootArticleDetail',
        TaskDetail: 'MediaCloudPortal-TaskDetail',
        ArticleAdd: 'MediaCloudPortal-ArticleAdd',
        ArticleDetail: 'MediaCloudPortal-ArticleDetail'
      },
      CommandReceiver: {
        RRCommandDetail: 'MediaCloudPortal-RRCommandDetail',
        RRArticleDetail: 'MediaCloudPortal-RRArticleDetail',
        ArticleAdd: 'MediaCloudPortal-ArticleAdd'
      },
      Userbar: {
        CommandReceiver: 'MediaCloudPortal-CommandReceiver',
        Notice: 'MediaCloudPortal-Notice',
        RRCommandDetail: 'MediaCloudPortal-RRCommandDetail',
        RRArticleDetail: 'MediaCloudPortal-RRArticleDetail',
        ArticleAdd: 'MediaCloudPortal-ArticleAdd',
        ClueAdd: 'MediaCloudPortal-ClueAdd'
      },
      ScreenControl: {
        ScreenPageConfig: 'MediaCloudRemoteRepository-ScreenPageConfig',
        ScreenPagePreview: 'MediaCloudRemoteRepository-ScreenPagePreview'
      },
      WatermarkSetting: {
        WatermarkAdd: 'MediaCloudMAM-WatermarkAdd'
      },
      RRClues: {
        RRClueDetail: 'MediaCloudRemoteRepository-RRClueDetail',
        RRCluesToCommand: 'MediaCloudRemoteRepository-RRCluesToCommand',
        RRClueEdit: 'MediaCloudRemoteRepository-RRClueEdit'
      },
      RRTopics: {
        RRTopicsDetail: 'MediaCloudRemoteRepository-RRTopicsDetail',
        RRTopicsToCommand: 'MediaCloudRemoteRepository-RRTopicsToCommand',
        RRTopicsEdit: 'MediaCloudRemoteRepository-RRTopicsEdit'
      },
      TVArticle: {
        // 广电文稿
        TVArticleAdd: 'MediaCloudPublishCenter-TVArticleAdd',
        TVArticleDetail: 'MediaCloudPublishCenter-TVArticleDetail',
        ArticleTraces: 'MediaCloudPublishCenter-ArticleTraces',
        // 串联单
        TVGroupAdd: 'MediaCloudPublishCenter-TVGroupAdd',
        TVGroupDetail: 'MediaCloudPublishCenter-TVGroupDetail',
        TVGroupPrint: 'MediaCloudPublishCenter-TVGroupPrint',
        TVGroupExport: 'MediaCloudPublishCenter-TVGroupExport',
        TVGroupArticleExport: 'MediaCloudPublishCenter-TVGroupArticleExport'
      }
    },
    namespace: 'dev'
  }
}
